var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniRestauranteResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "yltmmqtq0a",
    width: 22,
    height: 20,
    x: 9,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 10h21.177v19.596H9V10.001z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#yltmmqtq0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M17.175 18.25l2.325 2.346 1.097-1.087c-1.433-.886-1.963-2.167-1.277-3.221l5.07-6.038c.25-.296.694-.334.99-.086.298.249.335.692.087.984l-4.46 5.319c.081.567.552 1.059 1.162.967l4.46-5.308c.249-.297.691-.335.983-.086.298.248.335.686.087.983l-4.46 5.32c.043.588.601 1.07 1.222 1.053l4.476-5.335c.248-.292.691-.335.989-.086.298.248.335.692.086.99l-5.07 6.042c-1.151.65-2.335.665-3.437-.736l-.962 1.38 5.227 5.285c.735 1.379-1.146 3.319-2.671 2.184l-3.925-5.513-3.935 5.626c-1.464 1.103-3.193-.518-2.426-2.016l5.238-5.189-2.01-2.826c-4 2.621-8.19-2.352-6.751-7.633.242-.675.789-1.146 1.496-1.281 4.87-1.178 9.859 4.687 6.39 7.962z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniRestauranteResting);
export default __webpack_public_path__ + "static/media/icon_mini_restaurante_resting.08796b45244652d5b72336edac74a51b.svg";
export { ForwardRef as ReactComponent };